import React, { useState, useEffect } from "react";
import { message, Table } from "antd";
import { useNavigate } from "react-router-dom";
import http from "../../../../../services/http";

export const SugestoesSorteiosItens = ({ idSorteio, dadosSorteio }) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [dados, setDados] = useState([]);

	useEffect(() => {
		if (idSorteio) {
			listarItens(idSorteio);
		}
	}, [idSorteio, dadosSorteio]);

	// LISTAR ITENS
	const listarItens = async (id) => {
		if (!id) return;
		setLoading(true);
		const api = await http("get", `v1/sugestoes_sorteios_itens/listar/${id}`, []);
		if (api.statusCode === 200) {
			setDados(api?.response?.data);
		} else {
			message.error(api.response.message);
			navigate("/sugestoes/sorteios");
		}
		setLoading(false);
	};

	// COLUNAS TABLE
	const columns = [
		{
			title: "Descrição",
			dataIndex: "descricao",
			sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
		},
		{
			title: "Ganhador",
			dataIndex: "ganhador",
			render: (_, e) => (!e.colaborador_matricula ? "-" : `${e.colaborador_matricula} - ${e.colaborador}`),
			sorter: (a, b) =>
				(!a.colaborador_matricula ? "-" : `${a.colaborador_matricula} - ${a.colaborador}`)?.localeCompare(
					!b.colaborador_matricula ? "-" : `${b.colaborador_matricula} - ${b.colaborador}`
				),
		},
	];

	return (
		<React.Fragment>
			<Table rowKey="id" loading={loading} scroll={{ x: 700 }} columns={columns} dataSource={dados} size="small" />
		</React.Fragment>
	);
};
